import {Container, Image, Row, Col} from 'react-bootstrap'
import {localise} from '../../services/LocalizationServices'
import {
  ICON_FB,
  LOGO_WHITE,
  ICON_YOUTUBE,
} from '../../constants/svgs'
import {
  ABOUT_ME_URL,
  SERVICES_URL,
  ROOT_URL,
  CONTACT_URL,
  TESTIMONIALS_URL,
  FACEBOOK_URL,
  YOUTUBE_URL
} from '../../constants/urls'
import {Link} from 'react-router-dom'
import styled from 'styled-components'
import {CONTACT_EMAIL} from '../../constants/env'
import {useNavigate} from 'react-router'

const FirstIconDiv = styled.div`margin-left: -15px;`

const Footer = () => {
  const toFacebook = () => {window.open(FACEBOOK_URL)}
  const toYoutube = () => {window.open(YOUTUBE_URL)}

  const NavLink = ({className, href, title}) => (
    <div className={`mt-2 ${className}`}>
      <Link className='text-decoration-none custom-link font-regular font-15 font-white' to={href}>
        {title}
      </Link>
    </div>
  )

  const SocialImg = ({img, alt, onClick}) => (
    <Image className='cursor-pointer mx-2 social-icon' src={img} width={48} height={48} alt={alt} onClick={onClick}/>
  )

  return (
    <div className='bg-green footer'>
      <Container className='pt-3 pb-5 bg-green'>
        <div className='w-100 footer-stack'>
          <Col className='mt-4' xs={12} lg={6}>
            <div className='footer-section-top-left'>
              <div className='nav-logo-div'>
                <Image src={LOGO_WHITE} height={40} alt={localise('alt.companyLogo')} />
                <div className='ms-2 nav-logo-footer-text'>{localise('footer.companyName')}</div>
              </div>
            </div>
          </Col>
          <Col className='mt-4' xs={12} lg={6}>
            <div className='mt-1 d-flex footer-section-top-right'>
              <NavLink className='mx-2' href={ROOT_URL} title={localise('nav.home')}/>
              <NavLink className='mx-2' href={ABOUT_ME_URL} title={localise('nav.about')}/>
              <NavLink className='mx-2' href={SERVICES_URL} title={localise('nav.services')}/>
              <NavLink className='mx-2' href={TESTIMONIALS_URL} title={localise('nav.testimonials')}/>
              <NavLink className='mx-2' href={CONTACT_URL} title={localise('nav.contactMe')}/>
            </div>
          </Col>
        </div>
        <div className='w-100 footer-stack'>
          <Col className='mt-4 footer-section-left' xs={12} sm={12} lg={6} xl={6}>
            <div className='font-body-bold font-white footer-section-left'>
              {localise('footer.addressTitle')}
            </div>
            <div className='mt-2'>
              <div className='font-body-regular font-white mb footer-section-left'>
                {localise('footer.addressLineOne')}
                <br />
                {localise('footer.addressLineTwo')}
                <br />
                {localise('footer.addressLineThree')}
              </div>
            </div>
          </Col>
          <Col className='mt-4' xs={12} sm={12} lg={6} xl={6}>
            <div className='font-body-bold font-white footer-section-right'>{localise('nav.contact')}</div>
            <div className='mt-2 footer-section-right'>
              <div className='font-body-regular font-white mb'>
                {localise('footer.emailAddressTitle')}
              </div>
              <Link className='text-decoration-none custom-link font-body-bold font-white' to={''} onClick={e => {
                window.location = `mailto:${CONTACT_EMAIL}`
                e.preventDefault()
              }}>
                {CONTACT_EMAIL}
              </Link>
              <div className='font-body-regular font-white mb mt-2'>
                {localise('footer.phoneTitle')}
              </div>
              <Link className='text-decoration-none custom-link font-body-bold font-white' to={''} onClick={e => {
                window.location = 'tel:0857125814'
                e.preventDefault()
              }}>
                {localise('footer.phoneNumber')}
              </Link>
            </div>
          </Col>
        </div>
        <div className='row'>
          <div className='mt-4 d-flex homepage-social-media'>
            <FirstIconDiv>
              <SocialImg img={ICON_FB} alt='facebook' onClick={toFacebook}/>
            </FirstIconDiv>
            <SocialImg img={ICON_YOUTUBE} alt='youtube' onClick={toYoutube}/>
          </div>
        </div>
        <div className='row'>
          <div className='mt-3 font-body-bold font-white'>{localise('nav.copyright')}</div>
        </div>
      </Container>
    </div>
  )
}

export default Footer